//#region Styles
import { Column } from "components/styles";
//#endregion
//#region Components
import LocationPlaceStep1 from "./components/LocationPlaceStep1/LocationPlaceStep1";
import LocationPlaceStep2 from "./components/LocationPlaceStep2/LocationPlaceStep2";
//#endregion

const PlaceControls = ({
    dataRelatedToForm, form, 
    changeField, errors
}) => {
    return (
        <Column gap="25px" marginTop="20px">
            <LocationPlaceStep1
                campusWidth="340px"
                dataRelatedToForm={dataRelatedToForm}
                form={form}
                changeField={changeField}
                errors={errors.place}/>
            <LocationPlaceStep2 
                dataRelatedToForm={dataRelatedToForm}
                errors={errors.place}
                form={form}
                changeField={changeField}/>
        </Column>
    );
}

export default PlaceControls;